import { AxiosError } from 'axios';
import tokenConfigurationApi from '../../api/auth/tokenConfigurationApi';
import type {
  CustomResponse,
  TokenConfiguration,
  TokenConfigurationRequest,
} from '../../types/auth/TokenConfigurationTypes';

const TokenConfigurationService = {
  get: async (): Promise<CustomResponse<TokenConfiguration>> =>
    (await tokenConfigurationApi.get()).data,

  save: async (
    payload: TokenConfigurationRequest,
    configurationExists: boolean
  ): Promise<CustomResponse<TokenConfiguration>> => {
    if (configurationExists) {
      return (await tokenConfigurationApi.update(payload)).data;
    }

    try {
      return (await tokenConfigurationApi.create(payload)).data;
    } catch (error) {
      const apiError = error as AxiosError<CustomResponse<unknown>>;

      if (apiError.response?.status === 409) {
        return (await tokenConfigurationApi.update(payload)).data;
      }

      throw error;
    }
  },

  remove: async (): Promise<CustomResponse<null>> =>
    (await tokenConfigurationApi.remove()).data,
};

export default TokenConfigurationService;
